import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ITableCertificationParams {
  // table vizportal id.
  id: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetTableCertificationRequest extends Request<ITableCertificationParams, IResult> {
  constructor(params: ITableCertificationParams) {
    super('setTableCertification', params);
  }
}
